module.exports = __webpack_public_path__ + "img/blog.37a4e1e8.svg";